module.exports = __webpack_public_path__ + "img/20.0af67895.jpg";